import './Loading.css'

const Loading = ({ 
  size = 'md', 
  text = '',
  fullScreen = false,
  className = '' 
}) => {
  const classNames = [
    'loading',
    `loading--${size}`,
    fullScreen && 'loading--fullscreen',
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classNames}>
      <div className="loading__spinner">
        <svg viewBox="0 0 50 50">
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg>
      </div>
      {text && <span className="loading__text">{text}</span>}
    </div>
  )
}

export default Loading
